import React from "react";
import { Route, Switch } from "react-router";
import AuthRoute from "../auth/components/routes/AuthRoute";
import { UserRole } from "../user/enums/UserRole";
import NotFound from "../pages/NotFound";
import { ProgramViewMorePage } from "./pages/ProgramViewMorePage";
import CardsPage from "./pages/CardsPage";

export function ProgramsRoutes({ path }: { path: string }) {
  return (
    <Route path={path}>
      <Switch>
        <AuthRoute
          exact
          path={path}
          roles={[
            UserRole.Owner,
            UserRole.Admin,
            UserRole.Support,
            UserRole.Agent,
            UserRole.Parent,
            UserRole.Student,
          ]}
          component={CardsPage}
        />
        <AuthRoute
          exact
          path={`${path}/:educationType/:id`}
          roles={[
            UserRole.Owner,
            UserRole.Admin,
            UserRole.Support,
            UserRole.Agent,
            UserRole.Parent,
            UserRole.Student,
          ]}
          component={ProgramViewMorePage}
        />
        <Route path={`${path}/*`} component={NotFound} />
      </Switch>
    </Route>
  );
}
